/*********************** Remove the default section after loading the Boost AI grid ************************/

function removeDefaultSection() {
    const defaultSection = document.querySelector('.js-main-collection-section');
    if (defaultSection) {
        defaultSection.remove();
    }
}

/*********************** Custom JS for Boost AI Search & Discovery  ************************/

if (window.boostSDAppConfig) {
    window.boostSDAppConfig.integration =  Object.assign({wishlists: 'plus'}, window.boostSDAppConfig.integration || {});
    removeDefaultSection();
}

// Start-Boost-#230938
function renderTrustpilotwidgets() {
    var timesRun = 0;
    var trustLoad = true;
    var myInterval = setInterval(function () {
        timesRun += 1;
        if (timesRun === 30) {
            clearInterval(myInterval);
        }
        if (typeof window.Trustpilot !== 'undefined' && trustLoad) {
            let trustpilotwidgets = [...document.querySelectorAll('.trustpilot-widget')];
            trustpilotwidgets.forEach((widget) => {
                window.Trustpilot.loadFromElement(widget);
            });
            trustLoad = false;
        }
    }, 100);
}

function buildTrustpilotWidget(data) {
    let productVariantSkus = [];
    let widgetHtml = '';
    let widgetLocale = '';
    let widgetBusinessunit = '';

    for (var i = 0; i < data.variants.length; i++) {
        productVariantSkus.push(data.variants[i].sku);
    }
    widgetLocale = 'en-US';
    widgetBusinessunit = '5bf3cd76608c550001c8463c';

    widgetHtml = `<div class="productitem--ratings">
                        <div class="trustpilot-prod-mini">
                        <div class="trustpilot-widget" data-locale="${widgetLocale}" data-template-id="577258fb31f02306e4e3aaf9" data-businessunit-id="${widgetBusinessunit}" data-style-height="24px" data-style-width="100%" data-theme="light" data-sku="${productVariantSkus}" data-scroll-to-list="true" data-style-alignment="left"  data-star-color="#00b67a" data-no-reviews="collapse">
                        </div>
                        </div>
                      </div>
                    `;

    return widgetHtml;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductListPagination', {
            name: 'ProductListClass',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        if (element) {
                            let parrent_el = element.getRootElm();
                          
                            if(window.innerWidth > 768 && window.innerWidth <= 1024) {
                              let productListWrap = parrent_el.querySelector('.boost-sd__product-list-grid--4-col');
                                if(productListWrap) {
                                    productListWrap.classList.remove('boost-sd__product-list-grid--4-col');
                                    productListWrap.classList.add('boost-sd__product-list-grid--2-col');

                                }
                            }

                            if(window.innerWidth > 1024 && window.innerWidth < 1300) {
                              let productListWrap = parrent_el.querySelector('.boost-sd__product-list-grid--4-col');
                                if(productListWrap) {
                                    productListWrap.classList.remove('boost-sd__product-list-grid--4-col');
                                    productListWrap.classList.add('boost-sd__product-list-grid--3-col');

                                }
                            }
                        }
                    } catch (e) {
                    }
                }
            })
        });
        
        componentRegistry.useComponentPlugin('ProductSwatch', {
            name: 'ProductSwatchOption',
            enabled: true,
            apply: () => ({
                props: (props) => {
                    props.maxItem = 2;
                    return props;
                },
                beforeRender(element) {
                    try {
                        if (element) {
                          let dom_el = element.getRootElm();
                          let options_arr = element.getParams().props.options;

                          if (options_arr.length == 1 && options_arr[0].labelAs == "product-image" || options_arr[0].labelAs == "color") {
                            dom_el.querySelector('.boost-sd__product-swatch-options').remove();
                          }
                        }
                    } catch (e) {
                    }
                }
            })
        });

        componentRegistry.useComponentPlugin('ProductItemWidget', {
            name: 'ProductItemWidget',
            enabled: true,
            apply: () => ({
                afterRender(element) {
                    try {
                        let productData = element.getParams().props.product;
                        let productItem = element.getRootElm();
                        
                        if (productItem) {
                            if (productItem.querySelector('.boost-sd__product-title')) {
                                var prodTitle = productItem.querySelector('.boost-sd__product-title').innerHTML;
                                var arr = prodTitle.split(' - ');

                                prodTitle = arr.filter(function (value, index, self) {
                                    return self.indexOf(value) === index;
                                }).join(' - ');
                                if (prodTitle) productItem.querySelector('.boost-sd__product-title').innerHTML = prodTitle;
                            }

                            // TrustPilot reviews
                            const reviewsHtml = buildTrustpilotWidget(productData);
                            if (productItem.querySelector('.boost-sd__product-link') && !productItem.querySelector('.productitem--ratings')) {
                                productItem.querySelector('.boost-sd__product-link').insertAdjacentHTML('beforeend', reviewsHtml);
                                renderTrustpilotwidgets();
                            }
                        }
                    } catch (error) {
                        // console.warn(error);
                    }
                },
            }),
        });

        componentRegistry.useComponentPlugin('ProductTitle', {
            name: 'Custom product title',
            enabled: true,
            apply: () => ({
                beforeRender(element) {
                    try {
                        if (element) {
                            let productTitle = element.getRootElm();
                            let h3 = document.createElement('h3');

                            h3.setAttribute('style', productTitle.getAttribute('style'));
                            h3.classList.add('boost-sd__product-title');
                            h3.innerHTML = productTitle.innerHTML;

                            productTitle.replaceWith(h3);
                        }
                    } catch (e) {
                    }
                }
            })
        });

        componentRegistry.useComponentPlugin('ProductItemWidget', {
            name: 'CustomProductSwatchMarkup',
            enabled: true,
            apply: () => ({
                beforeRender(element) {
                    try {
                        let productItem = element.getRootElm();
                        
                        if (productItem) {
                            let countSwatches = 0;

                            switch (productItem.querySelectorAll('.boost-sd__product-swatch').length) {
                                case 2:
                                    break;
                                case 1:
                                    countSwatches = 1
                                    break;
                                case 0:
                                    countSwatches = 2
                                    break;

                            }

                            for (let i = 1; i <= countSwatches; i++) {
                                let emptySwatchEl = document.createElement('div');
                                emptySwatchEl.classList.add('boost-sd__product-swatch', 'boost-sd__product-swatch--full-width', `boost-sd__product-swatch--${i}`);
                                productItem.querySelector('.boost-sd__product-price').insertAdjacentElement('afterend', emptySwatchEl);
                            }
                        }
                    } catch (error) {
                        // console.warn(error);
                    }
                },
            }),
        });
    }
]);
// End-Boost-#230938